import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight, QrCodeIcon } from "lucide-react";
import { useCallback, useState } from "react";
import { FaCalculator, FaGlobe, FaRegLightbulb } from "react-icons/fa";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import hackerIcon from "../../assets/hackerIcon.png";
import { useDispatch } from "react-redux";
import { getVotacionesCount, postVotation } from "../../slices/votacionesSlice";
import { useNavigate } from "react-router-dom";

export default function Votar() {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {}, []);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const handleSubmit = (votate) => {
    dispatch(postVotation(votate));
    dispatch(getVotacionesCount());
    navigate("/formulario");
  };

  return (
    <div
      className="w-full h-screen"
      style={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          background: { color: "#000" },
          fpsLimit: 120,
          particles: {
            number: { value: 200 },
            color: { value: ["#FF0000", "#FF7F00"] },
            shape: {
              type: "circle",
            },
            move: {
              enable: true,
              speed: 2,
              direction: "none",
              outMode: "bounce",
              random: true,
              straight: false,
            },
            size: {
              value: { min: 1, max: 3 },
            },
            opacity: {
              value: { min: 0.1, max: 0.5 },
            },
          },
          interactivity: {
            events: {
              onHover: { enable: true, mode: "repulse" },
              onClick: { enable: true, mode: "push" },
            },
          },
        }}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100vh",
          zIndex: -1,
        }}
      />
      <AnimatePresence>
        <motion.div
          className="flex flex-wrap sm:mt-0 mt-5 z-10 relative"
          initial={{ y: "100%" }}
          animate={{ y: "0%" }}
          exit={{ y: "100%" }}
          transition={{ duration: 0.5 }}
        >
          {/* Sección 1 */}
          <div className="section1 w-[50%] sm:h-screen   font-poppina ">
            <div
              onClick={() => handleSubmit(1)}
              className="w-full h-[50%] flex cursor-pointer justify-center items-center"
            >
              <motion.div
                className="relative border border-opacity-20 sm:w-[600px] w-[180px] sm:h-[400px] h-[40vh] flex flex-col justify-center items-center p-4 rounded-lg shadow-2xl hover:shadow-3xl transition-all duration-300"
                whileHover={{ scale: 1.05 }} // Efecto de escala al hacer hover
              >
                <FaCalculator className="sm:w-20 sm:h-20 w-10 h-10 mb-5 text-white" />
                <h1 className="text-white text-center sm:text-4xl text-xl font-semibold mb-4 relative z-10">
                  Tips para cotizar un software
                </h1>
                <p className="text-gray-300 text-center sm:text-lg relative z-10">
                  Aprende a cotizar proyectos de software de manera efectiva.
                </p>
              </motion.div>
            </div>

            <div
              onClick={() => handleSubmit(2)}
              className="w-full h-[50%] cursor-pointer sm:mt-0 mt-5 flex justify-center items-center"
            >
              <motion.div
                className="relative border border-opacity-20 sm:w-[600px] w-[180px] sm:h-[400px] h-[40vh] flex flex-col justify-center items-center p-4 rounded-lg shadow-2xl hover:shadow-3xl transition-all duration-300"
                whileHover={{ scale: 1.05 }}
              >
                <FaRegLightbulb className="sm:w-20 sm:h-20 w-10 h-10 mb-5 text-white" />
                <h1 className="text-white text-center sm:text-4xl  font-semibold mb-4 relative z-10">
                  Como no cagarla emprendiendo en tecnología
                </h1>
                <p className="text-gray-300 text-center sm:text-lg text-sm relative z-10">
                  Consejos clave para evitar errores comunes en el
                  emprendimiento tecnológico.
                </p>
              </motion.div>
            </div>
          </div>

          <div className="section2 w-[50%] sm:my-0  font-poppina">
            <div
              onClick={() => handleSubmit(3)}
              className="w-full h-[50%] cursor-pointer flex justify-center items-center"
            >
              <motion.div
                className="relative border border-opacity-20 sm:w-[600px] w-[180px] sm:h-[400px] h-[40vh] flex flex-col justify-center items-center p-4 rounded-lg shadow-2xl hover:shadow-3xl transition-all duration-300"
                whileHover={{ scale: 1.05 }}
              >
                <FaGlobe className="sm:w-20 sm:h-20 w-10 h-10  mb-5 text-white" />
                <h1 className="text-white text-center sm:text-3xl font-semibold mb-4 flex items-center relative z-10">
                  <div className="sm:flex text-xl items-center block">
                    <p className="sm:text-2xl">La tecnología</p>
                    <ArrowRight className="mx-1 w- sm:block hidden  h-8" />
                    <p className="sm:text-2xl">Presente</p>
                    <ArrowRight className="mx-1 w-7 sm:block hidden  h-8" />
                    <p className="sm:text-2xl">Futuro</p>
                  </div>
                </h1>
                <p className="text-gray-300 text-center sm:text-lg text-md relative z-10">
                  Explora cómo la tecnología está moldeando el presente y el
                  futuro.
                </p>
              </motion.div>
            </div>

            <div
              onClick={() => handleSubmit(4)}
              className="w-full h-[50%] cursor-pointer sm:mt-0 mt-5  flex justify-center items-center"
            >
              <motion.div
                className="relative border border-opacity-20 sm:w-[600px] w-[180px] sm:h-[400px] h-[40vh] flex flex-col justify-center items-center p-4 rounded-lg shadow-2xl hover:shadow-3xl transition-all duration-300"
                whileHover={{ scale: 1.05 }}
              >
                <img
                  src={hackerIcon}
                  alt=""
                  className="sm:w-24 sm:h-24 w-10 h-10 mb-6 filter drop-shadow-lg relative z-10"
                />
                <h1 className="text-white text-center sm:text-4xl text-xl font-semibold mb-4 relative z-10">
                  Hackeo: Mitos y Verdades
                </h1>
                <p className="text-gray-300 text-center sm:text-lg text-md relative z-10">
                  Descubre la realidad detrás de los mitos comunes sobre el
                  hackeo.
                </p>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
